module.exports = __webpack_public_path__ + "static/img/banner-1.6718ecc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner-1.jpg
// module id = Pb69
// module chunks = 1